import { useState } from 'react';
import { copyToClipboard, extractTextFromHtml } from '../utils/textHelpers';
import { useAppContext } from '../contexts/AppContext';

export const useCopyFunctionality = () => {
  const { actions } = useAppContext();
  const { setReportText } = actions;
  const [copyStatus, setCopyStatus] = useState('');

  const showCopyStatus = (message) => {
    setCopyStatus(message);
    setTimeout(() => setCopyStatus(''), 3000);
  };

  const handleCopySuggestions = async (suggestions) => {
    if (!suggestions) {
      showCopyStatus('No suggestions to copy');
      return;
    }

    try {
      // Extract text if it's HTML
      const textToCopy = suggestions.includes('<!DOCTYPE html>') 
        ? extractTextFromHtml(suggestions)
        : suggestions;
      
      const success = await copyToClipboard(textToCopy);
      if (success) {
        showCopyStatus('Suggestions copied to clipboard!');
      } else {
        showCopyStatus('Failed to copy suggestions');
      }
    } catch (error) {
      console.error('Error copying suggestions:', error);
      showCopyStatus('Error copying suggestions');
    }
  };

  const handleCopyToEditor = async (suggestions) => {
    if (!suggestions) {
      showCopyStatus('No suggestions to copy to editor');
      return;
    }

    try {
      // Extract text if it's HTML
      const textToCopy = suggestions.includes('<!DOCTYPE html>') 
        ? extractTextFromHtml(suggestions)
        : suggestions;
      
      setReportText(prev => prev + '\n\n' + textToCopy);
      showCopyStatus('Suggestions added to editor!');
    } catch (error) {
      console.error('Error copying to editor:', error);
      showCopyStatus('Error copying to editor');
    }
  };

  return {
    copyStatus,
    handleCopySuggestions,
    handleCopyToEditor
  };
}; 